import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/dashboard";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/dashboard")(
  enRouteOptions(routeOptions, {
    svPath: "/dashboard",
    title: 'My page – Alkoholprovet',
    description: 'Your progress, statistics and premium resources.',
    noindex: true,
  }),
);
